module.exports = __webpack_public_path__ + "media/images/light_grey_4_lines-96dccf2c85f313ad84ff09574f3d8f60.svg";